import React, { Component } from 'react';
import { Row, Col, Input, Button, Spin, Space, DatePicker, message, Card } from 'antd'
import { DoubleRightOutlined, PlusOutlined } from '@ant-design/icons'
import removeTrailingZeros from 'remove-trailing-zeros'
import moment from 'moment'
import SearchAutoComplete from '../autocomplete/search'
import TransferList from './stock_transfer_list'
import DateRangeSelector from '../common/date_range_selector'
// import { Container } from './styles';

export default class StockTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAvailableQty: false,
      list: [],
      fromStockLocation: this.props.defaultStockLocation,
      toStockLocation: null,
      date: moment(),
      loadingTransfer: false,
      comments: ''
    }
  }

  addProduct = () => {
    const { list, variant, qty, availableQty} = this.state

    if(list.find( item => item.id == variant.value)){
      message.error('This item already added. To change Qty, please select the Qty value in the table.');
      return false;
    }

    if ( isNaN( parseFloat(qty) ) || parseFloat(qty) > availableQty)
    {
      message.error(`Invalid Qty. Available Qty is ${availableQty}.`)
      return false;
    }
    const item = {
      key: list.length,
      id: variant.value,
      name: variant.label,
      qty: qty,
      availableQty: availableQty,
    }
    const items = this.state.list.concat(item)
    this.setState({list: items, qty: ""})
  }

  productSelectionHandler = (variant) => {
    this.setState({ loadingAvailableQty: true })
    const stockLocationId  = this.state.fromStockLocation.value
    const url = Biscraft.routes.api.stocks_path + "/stock_count" + 
      "?variant_id=" + variant.value + "&stock_location_id=" + stockLocationId + "&token=" + Spree.api_key
    fetch(url)
      .then(response => response.json())
      .then(results => {
        this.setState({ variant, loadingAvailableQty: false, availableQty: removeTrailingZeros(results.count_on_hand) })

      });
  }

  handleListEdit = (list) => {
    this.setState({ list })

  }

  validateForm = () => {
    let isValid = true;
    const { fromStockLocation, toStockLocation, list, date } = this.state;
    if(!fromStockLocation)
    {
      message.error('From Transfer Location missing!')
      isValid = false
    }
    if (!toStockLocation) {
      message.error('To Transfer Location missing')
      isValid = false
    }
    if (!date) {
      message.error('Date is missing')
      isValid = false
    }    
    if (list.length == 0) {
      message.error('Items to transfer missing')
      isValid = false
    }    

    if (isValid && fromStockLocation.value == toStockLocation.value)
    {
      message.error("From and To Transfer Location Can't be the same! ")
      isValid = false

    }

    return isValid;
  }

  transerStock = async () => {

    if(!this.validateForm()) return false;

    const me = this
    me.setState({loadingTransfer: true})

    const url = Biscraft.routes.api.stocks_path + "/transfer.json" + "?token=" + Spree.api_key
    const { list, fromStockLocation, toStockLocation, date, comments } = this.state
    const body = JSON.stringify({ list, fromStockLocation, toStockLocation, date, comments })

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
      }
    ).then(response => response.json())
    .then( result =>{ 
      let { list } = this.state
      list.forEach( el => {
        el.transferFail = false;
        if( result.errors.indexOf(el.id) > -1 ){
          el.transferFail = true;
        }
      })
      this.setState({ list: [] })
      message.info('Items transferred successfully!')

      console.log("result:::", result) 
    })

    .finally(() => me.setState({ loadingTransfer: false }) )
  }
  
  showSearchResult = () => {

    let { startDate, endDate, fromStockLocation, toStockLocation} = this.state 
    // debugger
    const query = `?from_date=${ifHasValue(startDate) && ifHasValue(startDate).format('ll')}&to_date=${ifHasValue(endDate) && ifHasValue(endDate).format('ll')}
                  &from_stock_location=${ifHasValue(fromStockLocation?.value)}&to_stock_location=${ifHasValue(toStockLocation?.value)}`
    // console.log('query', query)

    location.href = `/stock_transfers${query}`
  }

  render() {
    return (
      <div>
        <Row>
          <Col span={24}>
            <Space>
            <SearchAutoComplete
              searchFor="stock_locations"
              placeholder="From Stock Location"
              defaultValue={this.props.defaultStockLocation}
              options={this.props.value}
              selectionHandler={(value) => this.setState({ fromStockLocation: value })}
              style= {{width: '250px'}}
            />


            <DoubleRightOutlined />


            <SearchAutoComplete
              searchFor="stock_locations"
              placeholder="To Stock Location"
              selectionHandler={(value) => this.setState({ toStockLocation: value })}
              style={{ width: '250px' }}

            />

              <DatePicker defaultValue={this.state.date} onChange={ (date) => this.setState({date}) } />
              <Input placeholder="Comments" style={{ width: '100%' }} onChange={(e) => this.setState({ comments: e.target.value })}></Input>
              <Card>
              <DateRangeSelector onChange={(startDate, endDate) => this.setState({ startDate, endDate })} />
              <Button type="dashed" onClick={this.showSearchResult}>Search</Button>
              </Card>
            </Space>
          </Col>
        </Row>
        <hr></hr>
        <Row gutter="20">
          <Col span="12">
            <SearchAutoComplete 
              searchFor = "products"
              placeholder = "Search Products"
              selectionHandler={(value) => this.productSelectionHandler(value) }
              disabled = {this.state.fromStockLocation == undefined }
              extraParams={'is_branch_inventory_item'}
            />
          </Col>

            <Col span="4">
            <Spin spinning={this.state.loadingAvailableQty}>
              <label>Available Qty: <label> {this.state.availableQty} </label> </label>
            </Spin>
             
            </Col>
            <Col span="4">
            <Input value={this.state.qty} onPressEnter={this.addProduct} onChange={ (e) => this.setState({qty: e.target.value})} />
            </Col>
            <Col span="4">
            <Button icon={<PlusOutlined />} 
              type="primary" onClick={this.addProduct}
              > Add </Button>
            </Col>
        </Row>

        <Row gutter="20">
          <Col span={24}>
            <br />
            <TransferList
              dataSource = {this.state.list}
              deleteHandler={ (key) => this.setState({ list: this.state.list.filter(item => item.key !== key) })}
              updateHandler = { (list) => this.handleListEdit(list)}
            />

            <div className="pull-right">
              <div  style={{marginTop: '10px'}}>

                <Button icon={<DoubleRightOutlined/>} 
                  onClick={this.transerStock} 
                  loading={this.state.loadingTransfer}
                  type="primary" size="large">
                    Transfer
                </Button>
              </div>

            </div>

          </Col>
        </Row>
      </div>
      );
  }
}
